import request from './fetcher/request'

/**
* 移除已绑定信息设备
* @params {String} op_server_id 设备server_id
* @params {String} op_status  prepare预移除 action移除
**/
function deleteDevice (data) {
  return request.post('/api/sdk/token/serverid/unbind', data)
}

function getDeviceList (data) {
  return request.post('/api/sdk/token/serverid/list', data)
}

function getDeviceConfig (data) {
  return request.post('/api/sdk/token/serverid/config', data)
}

export { deleteDevice, getDeviceList, getDeviceConfig }
